import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fileSize',
  standalone: true,
})
export class FileSizePipe implements PipeTransform {
  transform(sizeInBytes: number): string {
    if (sizeInBytes <= 0) return '0 B';

    const units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const index = Math.floor(Math.log(sizeInBytes) / Math.log(1024));
    const size = parseFloat((sizeInBytes / Math.pow(1024, index)).toFixed(2));
    const unit = units[index];
    return `${size} ${unit}`;
  }
}
